import React, {
  useState,
  useEffect,
  useLayoutEffect,
  useRef,
  Component,
} from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  FilterJsonExactlyMatching,
  formateDate,
  getEndOfMonth,
  getStartOfMonth,
  SortTheList,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import MobileInput from "../MobileInput/MobileInput";
import DragDrop from "../DragDrop/DragDrop";
import { useSearchParams } from "react-router-dom";
import QuillEditor from "../QuillEditor";
import ContentLibrary from "./ContentLibrary";
import { showErrorMessage } from "../Shared/Toast";

function BlogArticle() {
  const globalState = useGlobalState();
  const [searchParams] = useSearchParams();
  const selectedMoverID: any = searchParams.get("ID");
  const [isAnimation, setIsAnimation] = useState(false);
  const [isAddNew, setIsAddNew] = useState(0);
  const [screenFields, setScreenFields] = useState<any[]>([]);
  const [addEditObject, setAddEditObject] = useState<any>({
    MGBlogArticleID: 0,
    MGBlogCategoryID: 0,
    MGBlogAuthorID: 0,
    Title: "",
    MinuteRead: "",
    ArticleDate: "",
    ShortArticle: "",
    FullArticle: "",
    ThumbnailImageURL: "",
    ArticleImageURL: "",
    FeaturedArticle: false,
    IsActive: false,
    PTOrderBy: 0,
    MetaTitle: "",
    MetaDescription: "",
    MetaKeywords: "",
    ThumbnailImageAlt: "",
    ThumbnailImageTitle: "",
    ArticleImageAlt: "",
    ArticleImageTitle: "",
    PageURL: "",
    ThumbnailImageName: "",
    ArticleImageName: "",
    ExtraTextField1: "",
  });
  const [screenData, setScreenData] = useState<any>([]);
  const [dropDowndata, setDropDowndata] = useState<any>([]);
  const [linkedRolesData, setLinkedRolesData] = useState<any>([]);
  const [rolesData, setRolesData] = useState<any>([]);
  const [isAddNewComponent, setIsAddNewComponent] = useState<number>(0);
  const [screenListData, setScreenListData] = useState<any>([]);
  const [showContentLibraryModal, setShowContentLibraryModal] = useState(false);

  useEffect(() => {
    getScreenListData();
    LoadUsersData();
  }, []);

  function getScreenListData() {
    setIsAnimation(true);
    axiosAuth
      .get(
        AppContext.APIURL +
          "api/MGBlogArticle/MGBlogArticleGetCompleteDataSetForForeignKeys"
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;

          // var l_arrTypes = [
          //   { PID: 1, Name: "Driver" },
          //   { PID: 2, Name: "Helper" },
          // ];
          // l_oResponse.push(l_arrTypes);

          // var l_arrTiers = [
          //   { PID: 1, Name: "1" },
          //   { PID: 2, Name: "2" },
          //   { PID: 3, Name: "3" },
          // ];
          // l_oResponse.push(l_arrTiers);

          setScreenListData(l_oResponse);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function LoadUsersData() {
    let object = {} as any;
    setIsAnimation(true);
    axiosAuth
      .get(
        AppContext.APIURL +
          "api/MGBlogArticle/MGBlogArticleGetCompleteGridData",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0];
          l_oResponse = FilterJsonExactlyMatching(
            l_oResponse,
            "IsDeleted",
            false
          );
          if (selectedMoverID && selectedMoverID > 0) {
            l_oResponse = FilterJsonExactlyMatching(
              l_oResponse,
              "MGBlogArticleID",
              selectedMoverID
            );
          }
          const deepCopy1 = JSON.parse(JSON.stringify(l_oResponse));
          const deepCopy2 = JSON.parse(JSON.stringify(l_oResponse));
          setThisGridListDataWithoutFilters(deepCopy1);
          setThisGridListData(deepCopy2);
          thisGridListDataRef.current = deepCopy2;
          setScreenData(l_oResponse);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function checkValidation() {
    var IsOkay = true;
    if (
      !addEditObject.MGBlogCategoryID ||
      addEditObject.MGBlogCategoryID == 0
    ) {
      showErrorMessage("Please select Blog category");
      IsOkay = false;
    } else if (!addEditObject.Title || addEditObject.Title == 0) {
      showErrorMessage("Please select H1 Tag");
      IsOkay = false;
    } else if (!addEditObject.MinuteRead || addEditObject.MinuteRead == "") {
      showErrorMessage("Please select Minute Read");
      IsOkay = false;
    } else if (!addEditObject.ArticleDate || addEditObject.ArticleDate == "") {
      showErrorMessage("Please select Article date");
      IsOkay = false;
    } else if (!addEditObject.PageURL || addEditObject.PageURL == "") {
      showErrorMessage("Page URL Required");
      IsOkay = false;
    }

    if (IsOkay == true) {
      saveScreenData();
    }
  }

  function saveScreenData() {
    setIsAnimation(true);
    let object = {} as any;
    object.MGBlogArticleID = addEditObject.MGBlogArticleID;
    object.MGBlogCategoryID = addEditObject.MGBlogCategoryID;
    object.MGBlogAuthorID = addEditObject.MGBlogAuthorID;
    object.Title = addEditObject.Title;
    object.MinuteRead = addEditObject.MinuteRead;
    object.ArticleDate = addEditObject.ArticleDate;
    object.ShortArticle = addEditObject.ShortArticle;
    object.FullArticle = addEditObject.FullArticle;
    object.ThumbnailImageURL = addEditObject.ThumbnailImageURL;
    object.ArticleImageURL = addEditObject.ArticleImageURL;
    object.FeaturedArticle = addEditObject.FeaturedArticle;
    object.IsActive = addEditObject.IsActive;
    object.PTOrderBy = addEditObject.PTOrderBy;
    object.MetaTitle = addEditObject.MetaTitle;
    object.MetaDescription = addEditObject.MetaDescription;
    object.MetaKeywords = addEditObject.MetaKeywords;
    object.ThumbnailImageAlt = addEditObject.ThumbnailImageAlt;
    object.ThumbnailImageTitle = addEditObject.ThumbnailImageTitle;
    object.ArticleImageAlt = addEditObject.ArticleImageAlt;
    object.ArticleImageTitle = addEditObject.ArticleImageTitle;
    object.PageURL = addEditObject.PageURL;
    object.ExtraTextField1 = addEditObject.ExtraTextField1;

    axiosAuth
      .post(
        AppContext.APIURL + "api/MGBlogArticle/MGBlogArticleSaveCustom",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          setIsAddNew(0);
          LoadUsersData();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function deleteThisRecord(pid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.MGBlogArticleID = pid;

    axiosAuth
      .post(
        AppContext.APIURL + "api/MGBlogArticle/MGBlogArticleDeleteRecord",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          // SaveFiles();
          LoadUsersData();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function GenerateURL() {
    setIsAnimation(true);
    let object = {
      MGBlogArticleID: addEditObject.MGBlogArticleID,
      Title: addEditObject.Title,
    };

    if (!addEditObject.Title || addEditObject.Title.trim() === "") {
      showErrorMessage("Please enter page url");
      setIsAnimation(false);
      return;
    }
    axiosAuth
      .post(AppContext.APIURL + "api/MGBlogArticle/GenerateURL", object)
      .then((response) => {
        if (response.data.Status === 1) {
          const generatedURL = response.data.Data[0].URL;
          setAddEditObject((prevState: any) => ({
            ...prevState,
            PageURL: generatedURL,
          }));
        } else {
          showErrorMessage(response.data.Message || "Failed to generate URL");
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        deleteThisRecord(obj.SelectedID);
      }
    }
    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  // file upload code
  const [previewUrl, setPreviewUrl] = useState<string>("");
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0];
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({
        x: event.clientX,
        y: event.clientY,
        totalWidth: window.innerWidth,
        totalHeight: window.innerHeight,
      });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = [];
    l_data = [...FilterData];
    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setThisGridListData(deepCopy);
    thisGridListDataRef.current = deepCopy;
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  const [filters, setFilters] = useState(["", "D"]);

  useLayoutEffect(() => {
    SetSortingImage();
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "MGBlogCategoryName")) {
        (
          document.getElementById(
            "imgSort" + "MGBlogCategoryName"
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "Title")) {
        (
          document.getElementById("imgSort" + "Title") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "MinuteRead")) {
        (
          document.getElementById("imgSort" + "MinuteRead") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "ArticleDate")) {
        (
          document.getElementById("imgSort" + "ArticleDate") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1]
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  const [SelectedMobileNumber, SetSelectedMobileNumber] = useState("");

  useEffect(() => {
    // console.log("Mobile", addEditObject.Mobile);
    SetSelectedMobileNumber(addEditObject.Mobile);
  }, [addEditObject.Mobile, isAddNew]);

  useEffect(() => {
    setAddEditObject((prevState: any) => ({
      ...prevState,
      MobileNo: SelectedMobileNumber,
    }));
  }, [SelectedMobileNumber]);

  //Dragdrop starts
  const [dragDropFeatures, setDragDropFeatures] = useState({
    ObjectID: 100,
    ObjectType: 100,
    MaxAllowedFiles: 1,
    UploadType: 1,
    FolderName: "Blog",
    PTUploadedFiles: [],
  });

  const [dragDropFeaturesThumbnail, setDragDropFeaturesThumbnail] = useState({
    ObjectID: 200,
    ObjectType: 200,
    MaxAllowedFiles: 1,
    UploadType: 1,
    FolderName: "Blog",
    PTUploadedFiles: [],
  });

  const [uploadFileList, setUploadFileList] = useState<any>([]);
  const [triggerChild, setTriggerChild] = useState(false);
  const [showDragdrop, setShowDragdrop] = useState(false);

  function handleDragDropCallback(ChildData: any) {
    if (ChildData.length == 0) {
      addEditObject.ArticleImageURL = "";
    }
    setUploadFileList(ChildData);
    SaveFiles(ChildData, 1);
  }

  function handleDragDropCallbackThumbnail(ChildData: any) {
    if (ChildData.length == 0) {
      addEditObject.ThumbnailImageURL = "";
    }
    setUploadFileList(ChildData);
    SaveFiles(ChildData, 2);
  }

  async function SaveFiles(ChildData: any, type: any) {
    // call this function for saving attachments, when you get this function responce call actuall function who save data in table.
    // let uploadFileList = UploadFileList;

    if (ChildData && ChildData.length > 0 && !ChildData[0].AlreadyUploaded) {
      let object = {} as any;
      object.typeid = 1;

      let thumbnailRatio = 220 / 340;
      let thumbnailDimensions = "340-220";

      if (ChildData[0].Ratio && ChildData[0].Ratio > thumbnailRatio) {
        thumbnailDimensions = "340-0";
      } else {
        thumbnailDimensions = "0-220";
      }

      if (type == 1) {
        object.attachmenttype = dragDropFeatures.ObjectType;
        object.objectid = dragDropFeatures.ObjectID;
        object.resoption = "0-1200-0,0-900-0,1-650-0,0-340-220,1";
      } else if (type == 2) {
        object.attachmenttype = dragDropFeaturesThumbnail.ObjectType;
        object.objectid = dragDropFeaturesThumbnail.ObjectID;
        object.resoption =
          "0-1200-0,0-900-0,1-" +
          thumbnailDimensions +
          ",0-" +
          thumbnailDimensions +
          ",1";
      }

      object.applicationid = 1;
      object.filesdata = ChildData;

      try {
        const response = await axiosAuth.post(
          AppContext.FilesAPI + "api/PTAttachment/SaveFilesDataV2",
          object
        );
        if (response.data.Status === 1) {
          // setTriggerChild(!triggerChild);
          let l_response = response.data.Data;
          if (type == 1) {
            l_response[0].S3Path = l_response[0].S3Path.replace(
              "/raw/",
              "/sm/"
            );
            addEditObject.ArticleImageURL = l_response[0].S3Path;
          } else if (type == 2) {
            l_response[0].S3Path = l_response[0].S3Path.replace(
              "/raw/",
              "/sm/"
            );
            addEditObject.ThumbnailImageURL = l_response[0].S3Path;
          }
        } else {
          console.log("error", response.data.Message);
        }
      } catch (error) {
        console.error("There was an error!", error);
      }
    }
  }
  //Dragdrop ends

  function setImageData(item: any) {
    let l_PTUploadedFiles: any = [];
    let l_PTUploadedFilesThumbnail: any = [];
    if (item.ArticleImageURL !== "") {
      let obj: any = {};
      obj.Name = item.ArticleImageURL;
      obj.FileURLDisplay = AppContext.GetFileIconToDisplay(
        item.ArticleImageURL
      );
      obj.FileURL = item.ArticleImageURL;
      obj.AlreadyUploaded = true;
      l_PTUploadedFiles.push(obj);

      setDragDropFeatures((prevState: any) => ({
        ...prevState,
        PTUploadedFiles: l_PTUploadedFiles,
      }));
    }

    if (item.ThumbnailImageURL !== "") {
      let obj: any = {};
      obj.Name = item.ThumbnailImageURL;
      obj.FileURLDisplay = AppContext.GetFileIconToDisplay(
        item.ThumbnailImageURL
      );
      obj.FileURL = item.ThumbnailImageURL;
      obj.AlreadyUploaded = true;
      l_PTUploadedFilesThumbnail.push(obj);

      setDragDropFeaturesThumbnail((prevState: any) => ({
        ...prevState,
        PTUploadedFiles: l_PTUploadedFilesThumbnail,
      }));
    }
  }

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />

      {thisGridListData && thisGridListData.length > 0 && (
        <ColumnFilterCheckboxList
          DataType={1}
          RefreshFilters={refreshFilters}
          ClearFilters={clearFilters}
          GridData={thisGridListData}
          ColumnName={selectedColumnName}
          ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
          GetFilteredLists={getFilteredLists}
          ReturnAllFilterdLists={{}}
          ClickPosition={clickPosition}
          Orientation={"Center"}
          ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
        />
      )}

      {isAddNew == 0 && (
        <>
          <div className="flex-d justify-btw mb-10">
            <span></span>
            <div className="flex-daj flex-gap10">
              <a
                className="link-btn btn-link-m"
                onClick={() => ClearAllFilters()}
              >
                Clear All Filters
              </a>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    setAddEditObject({
                      MGBlogArticleID: 0,
                      MGBlogCategoryID: 0,
                      MGBlogAuthorID: 0,
                      Title: "",
                      MinuteRead: "",
                      ArticleDate: "",
                      ShortArticle: "",
                      FullArticle: "",
                      ThumbnailImageURL: "",
                      ArticleImageURL: "",
                      FeaturedArticle: false,
                      IsActive: false,
                      PTOrderBy: 0,
                      MetaTitle: "",
                      MetaDescription: "",
                      MetaKeywords: "",
                      ThumbnailImageAlt: "",
                      ThumbnailImageTitle: "",
                      ArticleImageAlt: "",
                      ArticleImageTitle: "",
                      PageURL: "",
                      ThumbnailImageName: "",
                      ArticleImageName: "",
                      ExtraTextField1:"",
                    });
                    setIsAddNew(1);
                    SetSelectedMobileNumber("");
                    // loadScreenFieldsData();
                  }}
                >
                  Add New
                </a>
              </div>
              <a
                className="btn-primary flex-daj btn-grid"
                title="Export"
                onClick={() =>
                  DownloadClientsDataInExcel("tblblogarticle", "Blog Article")
                }
              >
                <img src="images/export.svg" width="18" height="18" />
              </a>
            </div>
          </div>
          <div className="flow-auto">
            <table className="reuse-table" id="tblblogarticle">
              <thead>
                <tr>
                  <th>Action</th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Blog Category
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "MGBlogCategoryName")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() =>
                            LoadWithSelectedSort("MGBlogCategoryName")
                          }
                          title={"Sort By Name"}
                        >
                          <span id={"imgSort" + "MGBlogCategoryName"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Blog Author
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "MGBlogAuthorName")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() =>
                            LoadWithSelectedSort("MGBlogAuthorName")
                          }
                          title={"Sort By Name"}
                        >
                          <span id={"imgSort" + "MGBlogAuthorName"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th className="min-col1">
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        H1 Tag
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "Title")}
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("Title")}
                          title={"Sort By H1 Tag"}
                        >
                          <span id={"imgSort" + "Title"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Minute Read
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "MinuteRead")}
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("MinuteRead")}
                          title={"Sort By Minute Read"}
                        >
                          <span id={"imgSort" + "MinuteRead"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Article Date
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "ArticleDate")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("ArticleDate")}
                          title={"Sort By Article Date"}
                        >
                          <span id={"imgSort" + "ArticleDate"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>Featured Article</th>
                  <th>Is Active</th>
                  <th>Order By</th>
                  <th>Title Tag</th>
                  <th className="min-col2">Meta Description</th>
                  <th className="min-col1">Meta Keywords</th>
                  <th>Thumbnail Image</th>
                  <th>Thumbnail Image Title</th>
                  <th>Article Image Alt</th>
                  <th>Article Image Title</th>
                  <th>Thumbnail Image</th>
                  <th>Article Image</th>
                  <th className="min-col2">Short Article</th>
                  <th className="min-col2">Full Article</th>
                  <th>Page URL</th>
                </tr>
              </thead>
              <tbody>
                {thisGridListData &&
                  thisGridListData.map((item: any, index: any) => (
                    <React.Fragment key={index}>
                      {!item.IsExcluded && (
                        <tr>
                          <td>
                            <div className="flex-daj gap-10">
                              <a
                                onClick={() => {
                                  setIsAddNew(2);
                                  SetSelectedMobileNumber("");
                                  // loadScreenFieldsData();
                                  setAddEditObject({
                                    MGBlogArticleID: item.MGBlogArticleID,
                                    MGBlogCategoryID: item.MGBlogCategoryID,
                                    MGBlogAuthorID: item.MGBlogAuthorID,
                                    Title: item.Title,
                                    MinuteRead: item.MinuteRead,
                                    ArticleDate: item.ArticleDate,
                                    ShortArticle: item.ShortArticle,
                                    FullArticle: item.FullArticle,
                                    ThumbnailImageURL: item.ThumbnailImageURL,
                                    ArticleImageURL: item.ArticleImageURL,
                                    FeaturedArticle: item.FeaturedArticle,
                                    IsActive: item.IsActive,
                                    PTOrderBy: item.PTOrderBy,
                                    MetaTitle: item.MetaTitle,
                                    MetaDescription: item.MetaDescription,
                                    MetaKeywords: item.MetaKeywords,
                                    ThumbnailImageAlt: item.ThumbnailImageAlt,
                                    ThumbnailImageTitle:
                                      item.ThumbnailImageTitle,
                                    ArticleImageAlt: item.ArticleImageAlt,
                                    ArticleImageTitle: item.ArticleImageTitle,
                                    PageURL: item.PageURL,
                                    ThumbnailImageName: item.ThumbnailImageName,
                                    ArticleImageName: item.ArticleImageName,
                                    ExtraTextField1:item.ExtraTextField1
                                  });
                                  setImageData(item);
                                }}
                              >
                                <img
                                  src="images/edit.svg"
                                  width="18px"
                                  height="18px"
                                  alt="Edit"
                                />
                              </a>
                              <a
                                onClick={() =>
                                  globalState.setConfirmationModalObject({
                                    ShowPopup: true,
                                    Heading: "Alert",
                                    Message:
                                      "Are your sure, you want to delete this record?",
                                    ID: 1,
                                    SelectedID: item.MGBlogArticleID,
                                    OtherID: 0,
                                  })
                                }
                              >
                                <img
                                  src="images/delete.png"
                                  width="18px"
                                  height="18px"
                                  alt="Delete"
                                />
                              </a>
                            </div>
                          </td>
                          <td>{item.MGBlogCategoryName}</td>
                          <td>{item.MGBlogAuthorName}</td>
                          <td>{item.Title}</td>
                          <td>{item.MinuteRead}</td>
                          <td>{formateDate(item.ArticleDate)}</td>
                          <td>{item.FeaturedArticle ? "True" : "False"}</td>
                          <td>{item.IsActive ? "True" : "False"}</td>
                          <td>{item.PTOrderBy}</td>
                          <td>{item.MetaTitle}</td>
                          <td>{item.MetaDescription}</td>
                          <td>{item.MetaKeywords}</td>
                          <td>{item.ThumbnailImageAlt}</td>
                          <td>{item.ThumbnailImageTitle}</td>
                          <td>{item.ArticleImageAlt}</td>
                          <td>{item.ArticleImageTitle}</td>
                          <td>
                            <img
                              src={item.ThumbnailImageURL == "" ? null:item.ThumbnailImageURL}
                              alt="img"
                              height={100}
                            />
                          </td>
                          <td>
                            <img
                              src={item.ArticleImageURL == "" ? null:item.ArticleImageURL}
                              alt="img"
                              height={100}
                            />
                          </td>
                          <td>
                            <span className="short-scroll">
                              {item.ShortArticle}
                            </span>
                          </td>
                          <td>
                            {/* {item.FullArticle} */}
                            <textarea
                            readOnly
                              value={item.FullArticle}
                              className="min-full-article"
                            ></textarea>
                          </td>
                          <td>{item.PageURL}</td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {(isAddNew == 1 || isAddNew == 2) && (
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <>
            <div className="grid-d fr-1111 gap-20">
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">
                  Blog Category:
                </span>
                <select
                  className="input-field w-100"
                  value={addEditObject.MGBlogCategoryID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MGBlogCategoryID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Blog Category</option>
                  {screenListData[0] &&
                    screenListData[0].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <React.Fragment key={index}>
                          <option value={item.PID}>{item.Name}</option>
                        </React.Fragment>
                      </React.Fragment>
                    ))}
                </select>
              </div>
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">
                  Blog Author:
                </span>
                <select
                  className="input-field w-100"
                  value={addEditObject.MGBlogAuthorID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MGBlogAuthorID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Blog Author</option>
                  {screenListData[1] &&
                    screenListData[1].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <React.Fragment key={index}>
                          <option value={item.MGBlogAuthorID}>{item.Name}</option>
                        </React.Fragment>
                      </React.Fragment>
                    ))}
                </select>
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">H1 Tag:</span>
                <textarea
                  className="input-field w-100"
                  rows={3}
                  value={addEditObject.Title}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Title: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Minute Read:
                </span>
                <input
                  className="input-field w-100"
                  type="number"
                  value={addEditObject.MinuteRead}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MinuteRead: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Article Date:
                </span>
                <input
                  className="input-field w-100"
                  placeholder="Date"
                  type="date"
                  value={moment(addEditObject.ArticleDate).format("YYYY-MM-DD")}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      ArticleDate: moment(e.target.value).format("YYYY-MM-DD"),
                    }))
                  }
                />
              </div>
            </div>
            <div className="grid-d mt-20">
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  <div className="flex-da flex-gap10">
                    Short Article:
                    <a
                      title="Manage Content Library"
                      className="flex-d library-btn"
                      onClick={() => setShowContentLibraryModal(true)}
                    >
                      <img
                        src="images/m-manage.svg"
                        width="18px"
                        height="18px"
                        alt="Edit"
                      />
                    </a>
                  </div>
                </span>

                <div className="ck-editor-container">
                  <QuillEditor
                    value={addEditObject.ShortArticle}
                    onChange={(value: string) =>
                      setAddEditObject((prev: any) => ({
                        ...prev,
                        ShortArticle: value,
                      }))
                    }
                  />
                </div>
              </div>
            </div>
            <div className="grid-d mt-20">
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  <div className="flex-da flex-gap10">
                    Full Article:
                    <a
                      title="Manage Content Library"
                      className="flex-d library-btn"
                      onClick={() => setShowContentLibraryModal(true)}
                    >
                      <img
                        src="images/m-manage.svg"
                        width="18px"
                        height="18px"
                        alt="Edit"
                      />
                    </a>
                  </div>
                </span>
                {/* <div className="ck-editor-container">
                  <CKEditor
                    editor={ClassicEditor as any}
                    data={addEditObject.FullArticle}
                    onChange={(event: any, editor: any) => {
                      const data = editor.getData();
                      setAddEditObject((prev: any) => ({
                        ...prev,
                        FullArticle: data,
                      }));
                    }}
                    config={{
                      toolbar: {
                        items: [
                          "sourceEditing",
                          "|",
                          "heading",
                          "|",
                          "bold",
                          "italic",
                          "underline",
                          "strikethrough",
                          "|",
                          "fontFamily",
                          "fontSize",
                          "fontColor",
                          "fontBackgroundColor",
                          "|",
                          "link",
                          "bulletedList",
                          "numberedList",
                          "outdent",
                          "indent",
                          "|",
                          "alignment",
                          "blockQuote",
                          "insertTable",
                          "|",
                          "imageUpload",
                          "mediaEmbed",
                          "|",
                          "undo",
                          "redo",
                        ],
                        shouldNotGroupWhenFull: true,
                      },
                      table: {
                        contentToolbar: [
                          "tableColumn",
                          "tableRow",
                          "mergeTableCells",
                        ],
                      },
                      // placeholder: "Enter your full article...",
                    }}
                  />
                </div> */}
                <div className="ck-editor-container">
                  <QuillEditor
                    value={addEditObject.FullArticle}
                    onChange={(value: string) =>
                      setAddEditObject((prev: any) => ({
                        ...prev,
                        FullArticle: value,
                      }))
                    }
                  />
                </div>
              </div>
            </div>
            {/* <div className="grid-d fr-11 gap-20 mt-20 flex-as">
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Thumbnail Image:
                </span>

                <div>
                  <div className="field-input grid-d g-c-fw">
                    <DragDrop
                      ParentFeatures={dragDropFeaturesThumbnail}
                      DragDropCallback={handleDragDropCallbackThumbnail}
                      TriggerChild={triggerChild}
                    />
                  </div>
                </div>
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Article Image:
                </span>

                <div>
                  <div className="field-input grid-d g-c-fw">
                    <DragDrop
                      ParentFeatures={dragDropFeatures}
                      DragDropCallback={handleDragDropCallback}
                      TriggerChild={triggerChild}
                    />
                  </div>
                </div>
              </div>
            </div> */}

            <div className="grid-d fr-11 gap-20 mt-20 flex-as">
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Thumbnail Image:
                </span>
                <textarea
                  className="input-field w-100"
                  rows={3}
                  value={addEditObject.ThumbnailImageURL}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      ThumbnailImageURL: e.target.value,
                    }))
                  }
                />
                <div className="contact-attachments">
                  <div className="remove--image">
                    <img
                      src={addEditObject.ThumbnailImageURL}
                      alt="img"
                      width="200"
                      height="200"
                    />
                  </div>
                </div>
                <span>{addEditObject.ThumbnailImageName}</span>
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Article Image:
                </span>
                <textarea
                  className="input-field w-100"
                  rows={3}
                  value={addEditObject.ArticleImageURL}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      ArticleImageURL: e.target.value,
                    }))
                  }
                />

                <div className="contact-attachments">
                  <div className="remove--image">
                    <img
                      src={addEditObject.ArticleImageURL}
                      alt="img"
                      width="200"
                      height="200"
                    />
                  </div>
                </div>

                <span>{addEditObject.ArticleImageName}</span>
              </div>
            </div>

            <div className="grid-d fr-1111 gap-20 mt-20 flex-as">
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Thumbnail Image Alt:
                </span>
                <input
                  className="input-field w-100"
                  value={addEditObject.ThumbnailImageAlt}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      ThumbnailImageAlt: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Thumbnail Image Title:
                </span>
                <input
                  className="input-field w-100"
                  value={addEditObject.ThumbnailImageTitle}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      ThumbnailImageTitle: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Article Image Alt:
                </span>
                <input
                  className="input-field w-100"
                  value={addEditObject.ArticleImageAlt}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      ArticleImageAlt: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Article Image Title:
                </span>
                <input
                  className="input-field w-100"
                  value={addEditObject.ArticleImageTitle}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      ArticleImageTitle: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3 flex-js text-left">
                <span className="font-12 text-left label-color">
                  Featured Article:
                </span>
                <input
                  className="wh-auto"
                  type="checkbox"
                  checked={addEditObject.FeaturedArticle}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      FeaturedArticle: e.target.checked,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3 flex-js text-left">
                <span className="font-12 text-left label-color">
                  Is Active:
                </span>
                <input
                  className="wh-auto"
                  type="checkbox"
                  checked={addEditObject.IsActive}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      IsActive: e.target.checked,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Order By:</span>
                <input
                  className="input-field w-100"
                  type="number"
                  value={addEditObject.PTOrderBy}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      PTOrderBy: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Title Tag:
                </span>
                <textarea
                  className="input-field w-100"
                  rows={3}
                  value={addEditObject.MetaTitle}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MetaTitle: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Meta Description:
                </span>
                <textarea
                  className="input-field w-100"
                  rows={3}
                  value={addEditObject.MetaDescription}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MetaDescription: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Meta Keywords:
                </span>
                <textarea
                  className="input-field w-100"
                  rows={3}
                  value={addEditObject.MetaKeywords}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MetaKeywords: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Page URL:</span>
                <input
                  className="input-field w-100"
                  value={addEditObject.PageURL}
                  onChange={(e) =>
                    setAddEditObject((prev: any) => ({
                      ...prev,
                      PageURL: e.target.value,
                    }))
                  }
                />
                <button className="gen-url" onClick={GenerateURL}>
                  Generate URL
                </button>
              </div>
               <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Schema:
                </span>
                <textarea
                  className="input-field w-100"
                  rows={3}
                  value={addEditObject.ExtraTextField1}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      ExtraTextField1: e.target.value,
                    }))
                  }
                />
              </div>
            </div>

            <div className="flex-daj gap-10 mt-20">
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => checkValidation()}
                >
                  {isAddNew == 1 ? "Save" : "Update"}
                </a>
              </div>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setIsAddNew(0)}
                >
                  Cancel
                </a>
              </div>
            </div>
          </>
        </div>
      )}

      {showContentLibraryModal && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner lg-popup-content">
              <div className="help-head flex-da justify-btw">
                Content Library
                <a
                  className="close-help"
                  onClick={() => setShowContentLibraryModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="mt-20 p-all0">
                <ContentLibrary />
              </div>
              <div className="flex-daj gap-10 mt-20">
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => setShowContentLibraryModal(false)}
                  >
                    Close
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default BlogArticle;
